<template>
  <div class="know">
    <div class="bottom_div">
      <a-table
        :columns="columnsList"
        :data-source="treeData"
        :pagination="false"
        :row-key="record => record.id"
        :expand-icon="expandIcon"
        :scroll="scrollObj"
      >
        <template
          v-for="column in columnsList"
          :slot="column.scopedSlots ? column.scopedSlots.customRender : ''"
          slot-scope="text, record"
        >
          <slot
            :name="column.scopedSlots ? column.scopedSlots.customRender : ''"
            v-bind="record"
          ></slot>
        </template>
        <!-- <template
          v-for="(column, i) in columnsList"
          :slot="column.slots ? column.slots.title : ''"
        >
          <slot v-bind="i">
            <a-checkbox :checked="allCheck" @change="changCheck" />
          </slot>
        </template> -->
        <!-- <span slot="rate" slot-scope="state">
          {{ state ? state + '%' : '--' }}
        </span>
        <span slot="edit" slot-scope="state">
          <a-button type="link"> 分层设置</a-button>
          <a-button type="link"> 验证变式题</a-button>
          <router-link
            :to="`/printTask/taskLearnReportDetail?knowName=${state.name}&knowId=${state.id}`"
          >
            <a-button type="link"> 查看详情</a-button>
          </router-link>
        </span> -->
      </a-table>
    </div>
  </div>
</template>

<script>
  export default {
    components: {},
    props: ['treeData', 'columnsList', 'scrollObj'],
    data() {
      return {
        questionCount: 0
      }
    },
    watch: {
      paramsData: {
        handler(val) {
          if (val.studentId && val.subjectId) {
            // 题型得分
            this.getKnowPoint()
          }
        },
        deep: true
      }
    },
    created() {},
    mounted() {},
    methods: {
      // 表格自定义展开图标
      expandIcon(props) {
        if (props.record.children && props.record.children.length > 0) {
          if (props.expanded) {
            //有数据-展开时候图标
            return (
              <a-icon
                type="caret-down"
                style="margin-right:5px"
                onClick={e => {
                  props.onExpand(props.record, e)
                }}
              />
            )
          } else {
            //有数据-未展开时候图标
            return (
              <a-icon
                type="caret-right"
                style="margin-right:5px"
                onClick={e => {
                  props.onExpand(props.record, e)
                }}
              />
            )
          }
        } else {
          //无数据-图标
          return <span style="margin-right:0px"></span>
        }
      },
      //   递归
      loopList(list, id) {
        list.forEach(item => {
          item.active = false
          if (item.id == id) {
            item.active = true
          }
          if (item.children) {
            this.loopList(item.children, id)
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .know {
    margin-bottom: 20px !important;
    .not-data {
      flex: auto;
      background-color: #fff;
      box-shadow: 0px 8px 16px 0px rgba(83, 97, 255, 0.08);
      border-radius: 8px;
      .not_data_box {
        padding: 120px;
      }
    }
    .title {
      height: 60px;
      line-height: 60px;
      padding-left: @padding-lg;
      border-bottom: @border-width-base solid #eaedf3;
      font-size: @font-size-base;
      font-weight: 600;
      color: @text-color-secondary;
    }
    .top_div {
      margin-bottom: 20px !important;
      display: flex;
      .left_div {
        min-height: 724px;
        width: 66%;
        margin-right: 20px;
        background: @blockbgc;
        box-shadow: 0px 8px 16px 0px rgba(83, 97, 255, 0.08);
        border-radius: 8px;
        .content {
          height: calc(100% - 60px);
          padding: 13px 27px;
        }
      }
      .right_div {
        min-height: 724px;
        width: 34%;
        background: @blockbgc;
        border-radius: @border-radius-base;
        box-shadow: 0px 8px 16px 0px rgba(83, 97, 255, 0.08);
        border-radius: 8px;
        .line {
          line-height: 46px;
          min-height: 46px;
          border-bottom: @border-width-base solid #eee;
          padding-left: @padding-lg;
          padding-right: 20px;
          font-size: @font-size-base;
          font-weight: 400;
          color: @text-color-secondary;
          .p {
            font-weight: 500;
            font-size: @font-size-lg;
          }
          .img_span {
            width: 32px;
            height: 46px;
            line-height: 46px;
            display: inline-block;
            text-align: center;
            margin-right: @font-size-sm;
            .img {
              width: 28px;
              margin-top: -4px;
            }
            .img2 {
              width: 28px;
            }
          }
          .right {
            float: right;
          }
        }
        .bing_div {
          width: 100%;
          height: 300px;
          padding: 11px 20px;
        }
        .know_list {
          padding: 0 24px 18px;
          .know_title {
            font-size: @font-size-base;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.85);
          }
          .son_know {
            line-height: 22px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.65);
            margin-top: @font-size-lg;
            .num {
              width: 20px;
              height: 20px;
              display: inline-block;
              margin-right: 24px;
              background: #f0f2f5;
              border-radius: 50%;
              text-align: center;
            }
          }
        }
      }
    }
    /deep/.bottom_div {
      .ant-table-thead {
        font-size: @font-size-base;
        font-weight: 400;
        color: #4b5d6c;
        height: 45px;
      }
      .ant-table-tbody {
        font-size: @font-size-base;
        font-weight: 400;
        color: #1d1f24;
        tr {
          height: 54px;
        }
      }
    }
  }
</style>
